module.exports = __webpack_public_path__ + "img/Kj.fcfd0216.png";